
 export const DocumentConvertor  = {
    "known_traveler_number" :"Known Travaler Number",
    "passenger_redress_number":"Passenger Redress Number",
    "checked":"Checked",
    "carry_on":"Cabin",
    "tax_id":"Tax Id"

 }